import React, { useRef } from 'react';
import { Carousel, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Navbar from "../Navbar/Navbar";
import Fotter from "../Fotter/Fotter";
import classes from './Project.module.scss';

function Project() {
    const windImages = [
        'https://i.imgur.com/ds4uRLC.jpeg',
        'https://i.imgur.com/afRXiXf.png',
        'https://i.imgur.com/DhV8HmP.jpeg',
    ];

    const exoImages = [
        'https://i.imgur.com/97WLHvO.png',
        'https://i.imgur.com/dLVQMlZ.png',
        'https://i.imgur.com/mxfvR4B.png',
    ];

    const exoCarouselRef = useRef();

    const carouselRef = useRef();

    return (
        <div className={classes['project']}>
            <div className={classes['project-container-one']}>
                <Navbar />
                <h2 className={classes['h2']}>PROJECTS</h2>
            </div>

            <div className={classes['bg-img']}>
                <h1 className={classes['h1']}>WIND TURBIN WT10</h1>

                <div className={classes['video-section']}>
                    <div className={classes['video']}>
                        <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                            <iframe
                                src="https://www.youtube.com/embed/oyFFvbV2xQk?autoplay=1&mute=1&controls=0&loop=1&playlist=oyFFvbV2xQk&disablekb=1&modestbranding=1&rel=0&playsinline=1"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    border: 'none',
                                    pointerEvents: 'none',
                                }}
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>

                <div className={classes['text-section']}>
                    <div className={classes['text']}>
                        <span className={classes['span']}>
                            <ul><li>Nominal power - 10 (kw)</li></ul>
                            <ul><li>Maximum power - 12 (kw)</li></ul>
                            <ul><li>Nominal wind speed - 8 (m/s)</li></ul>
                            <ul><li>Initial wind speed - 4 (m/s)</li></ul>
                            <ul><li>Automatic wing and wheel control</li></ul>
                        </span>
                        <span className={classes['span']}>
                           <ul><li>Generator type self-exciting</li></ul>
                            <ul><li>Tower height - 12 (m)</li></ul>
                            <ul><li>Type with horizontal axis</li></ul>
                            <ul><li>Wing material fiberglass</li></ul>
                            <ul><li>Wheel diameter - 10 (m)</li></ul>
                            <ul><li>Number of wings - 3</li></ul>
                        </span>
                    </div>
                </div>

                {/* Ant Design Carousel for wind images */}
                <div className={classes['carousel-wrapper']}>
                    <Button
                        shape="circle"
                        icon={<LeftOutlined />}
                        onClick={() => carouselRef.current.prev()}
                        className={classes['carousel-btn-left']}
                    />
                    <Carousel
                        ref={carouselRef}
                        className={classes['carousel']}
                        dots
                        autoplay
                        autoplaySpeed={5000}
                        draggable
                    >
                        {windImages.map((src, index) => (
                            <div key={index} className={classes['carousel-item']}>
                                <img
                                    src={src}
                                    alt={`Wind Turbine ${index + 1}`}
                                    className={classes['carousel-img']}
                                />
                            </div>
                        ))}
                    </Carousel>
                    <Button
                        shape="circle"
                        icon={<RightOutlined />}
                        onClick={() => carouselRef.current.next()}
                        className={classes['carousel-btn-right']}
                    />
                </div>


                <h1 className={classes['h1']}>EXOSKELETON AW-EX01</h1>

                <div className={classes['carousel-wrapper']}>
                    <Button
                        shape="circle"
                        icon={<LeftOutlined />}
                        onClick={() => exoCarouselRef.current.prev()}
                        className={classes['carousel-btn-left']}
                    />
                    <Carousel
                        ref={exoCarouselRef}
                        className={classes['carousel']}
                        dots
                        autoplay
                        autoplaySpeed={5000}
                        draggable
                    >
                        {exoImages.map((src, index) => (
                            <div key={index} className={classes['carousel-item']}>
                                <img
                                    src={src}
                                    alt={`Exoskeleton ${index + 1}`}
                                    className={classes['carousel-img']}
                                />
                            </div>
                        ))}
                    </Carousel>
                    <Button
                        shape="circle"
                        icon={<RightOutlined />}
                        onClick={() => exoCarouselRef.current.next()}
                        className={classes['carousel-btn-right']}
                    />
                </div>


                <div className={classes['text-section-two']}>
                    <div className={classes['texts']}>
                        <span className={classes['span']}>
                           <ul><li> Exoskeleton transfers loads through the exoskeleton to
                            the ground in all working positions and allows
                            operators to use heavy tools as if they were weightless.</li></ul>
                            <br /><br />
                          <ul><li>The construction has modifying link lengths.
                            It can be used in different production processes
                            where humans need to operate with weighty tools.</li></ul>
                        </span>
                    </div>
                </div>
            </div>

            <div style={{ width: '100%', height: '10vh', background: '#191A1A', marginTop: '-2px' }}></div>
            <Fotter />
        </div>
    );
}

export default Project;
